export default __webpack_public_path__ + "static/media/pr.7aa603b4.svg";